import React, { useState } from 'react';
import OptionsPicker from '../OptionsPicker';
import ACHInput from '../ACHInput';
import CreditCardInput from '../CreditCardInput';
import Flexor from '../Flexor';
import H4 from '../Text/H4';
import CreditCardIcon from './credit_card.svg';
import BankIcon from './bank.svg';
import { Container } from './styled.js';

function PaymentMethodInput({
  submit = () => { },
  processorTypes = {
    cc: 'stripe',
    ach: 'stripe',
  },
  title = 'Payment Method',
  onToken,
  next,
  nextButtonLabel,
  ...other
}) {
  const paymentOptionLabels = [];
  const paymentOptions = [];

  if (processorTypes['cc'] === 'card_connect' || processorTypes['cc'] === 'stripe') {
    paymentOptionLabels.push('Credit Card');
    paymentOptions.push('cc');
  }

  if (processorTypes['ach'] === 'dwolla' || processorTypes['ach'] === 'legacy') {
    paymentOptionLabels.push('Bank Account');
    paymentOptions.push('ach');
  }

  const [paymentType, setPaymentType] = useState(paymentOptions[0]);
  let content = <div />;
  const processor = processorTypes[paymentType];

  if (paymentType === 'cc') {
    content = <CreditCardInput
      {...other}
      nextButtonLabel={nextButtonLabel}
      next={next}
      onToken={onToken}
      submit={(data) => {
        submit({
          ...data,
          paymentType,
          processorType: processor,
        });
      }}
      processorType={processor} />;
  } else if (paymentType === 'ach') {
    content = <ACHInput
      {...other}
      next={next}
      onToken={onToken}
      submit={(data) => {
        submit({
          ...data,
          paymentType,
          processorType: processor,
        });
      }}
      processorType={processor} />;
  }
  return (
    <Container minHeight={paymentType === 'ach' && processor === 'dwolla' ? 'calc(90vh - 56px)' : ''}>
      {title && (
        <>
          <Flexor flex="0 0 20px" />
          <H4>{title}</H4>
        </>
      )}
      <Flexor flex="0 0 20px" />
      {
        paymentOptions.length > 1 &&
        <>
          <OptionsPicker
            update={setPaymentType}
            value={paymentType}
            options={paymentOptionLabels}
            icons={[CreditCardIcon, BankIcon]}
            values={paymentOptions} />
          <Flexor flex="0 0 20px" />
        </>
      }
      {content}
      <Flexor flex="1 0 20px" />
    </Container>
  );
}

export default PaymentMethodInput;